import { Pipe, PipeTransform } from '@angular/core';
import { CurrencyPipe, DatePipe } from '@angular/common';
import { DomSanitizer } from '@angular/platform-browser';

import { Align } from './../../enums/align.enum';
import { DataType } from './../../enums/datatype.enum';
import { Metadata } from './../../list/metadata/metadata.component';
import { ResultsetPipeUtil } from './resultset-pipe.util';
import { VerticalAlign } from '../../enums/vertical-align.enum';
import { GridUtil } from '../../list/grid-util';


@Pipe({
  name: 'resultsetPipe'
})
export class ResultsetPipe implements PipeTransform {


    constructor(
        private datePipe: DatePipe
        , private domSanitizer: DomSanitizer
        , private currencyPipe: CurrencyPipe
    ) {}

    private resultsetPipeUtil = new ResultsetPipeUtil(this.datePipe,
                                                      this.domSanitizer,
                                                      this.currencyPipe);


    transform(valorCelulas: any
              , metadata: Metadata
              , rowIndex: number
              , retornarApenasValor?: boolean): any {

        let valorRetorno: any = null;
        try {
          this.setDefaultOptions(metadata);

          if (metadata.fnOperacaoNaoPermitida) {
            if (metadata.fnOperacaoNaoPermitida(valorCelulas)) {
              return GridUtil.HTML_BLOCK_ICON;
            }
          }

          // se existir a funcao e a mesma retornar FALSE a intencao do desenvolvedor eh esconder a celula.
          if (metadata.fnExibirValorCelula) {
            if (!metadata.fnExibirValorCelula(valorCelulas)) {
              return '';
            }
          }

          valorRetorno = this.resultsetPipeUtil.procurarValorDoAtributo(metadata.fieldId, valorCelulas);

          // tratar valor nao encontrado (null no JSON) ou fieldId nao encontrado
          if (valorRetorno === null) {
              valorRetorno = '';
          }
          else if (valorRetorno === undefined) {
              if (!metadata.podeNaoExistir) {
                  console.error(JSON.stringify(valorCelulas));
                  throw new ReferenceError('verifique o atributo: ' + metadata.fieldId);
              }
          }

          if (metadata.fnValorCelula) {
            valorRetorno = metadata.fnValorCelula(valorCelulas);
          }

          // TRATAR DADO DE ACORDO COM O TIPO DE DATA
          valorRetorno = this.resultsetPipeUtil.tratarDadoPeloDataType(metadata, valorRetorno, rowIndex, valorCelulas);

          if (retornarApenasValor) {
            return this.domSanitizer.bypassSecurityTrustHtml(valorRetorno);
          }
          else if (metadata.editable) {
            const disableClass = metadata.disabled ? 'resultset-btn-disabled' : '';

            valorRetorno = `<i id='icon_edit__${metadata.fieldId}_${rowIndex}'
                                class='material-icons editable-icon grid-material-mini-icon ${disableClass}' style='margin-right:4px;' title='${metadata.title}'>edit</i>
                                <span style='pointer-events: none;' onclick='return false;'>${valorRetorno}</span>`;

            valorRetorno = this.domSanitizer.bypassSecurityTrustHtml(valorRetorno);
          }
        } catch (e) {
            console.error(e.message);
            return  '<font color=red>' + e.message + '</font>';
        }

        return valorRetorno;
    }

    setDefaultOptions(metadata: Metadata) {
      if ( !metadata.dataType ) {
        metadata.dataType = DataType.TEXT;
      }

      if ( !metadata.align ) {
        if ( metadata.dataType === DataType.BUTTON ||
             metadata.dataType === DataType.DATE ||
             metadata.dataType === DataType.DATETIME ||
             metadata.dataType === DataType.TAG_ON_OFF ) {
          metadata.align = Align.CENTER;
        }
        else if ( metadata.dataType === DataType.CURRENCY ||
                  metadata.dataType === DataType.NUMBER ||
                  metadata.dataType === DataType.DECIMAL ) {
          metadata.align = Align.RIGHT;
        }
        else {
          metadata.align = Align.LEFT;
        }
      }

      if ( !metadata.title ) {
        metadata.title = '';
      }

      if ( !metadata.verticalAlign && metadata.dataType === DataType.OBJECT ) {
        metadata.verticalAlign = VerticalAlign.TOP;
      }
    }
}
